export const state = {
  stripeInfoPending: false,
  stripeInfo: null,
  stripeInfoError: null,
}
